// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box-item {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  padding: 10px 10px 10px 15px;\n}\n", ""]);
// Exports
module.exports = exports;
